import { ENABLED_COUPONS_CONFIG, COUPON_FLAG_REQUIREMENTS } from './config';

/**
 * Determines if coupons should be enabled for a user/product combination
 * @param {object} userEntitlements - User entitlements object with .has() method
 * @param {string} serviceCode - Product service name (e.g., 'wfg_initial_report')
 * @param {Array} config - Configuration array (defaults to ENABLED_COUPONS_CONFIG)
 * @returns {boolean} - True if coupons should be enabled
 */
export const shouldEnableCoupons = (
  userEntitlements,
  serviceCode,
  config = ENABLED_COUPONS_CONFIG
) => config.some((rule) => {
  const hasEntitlement = userEntitlements?.has(rule.entitlement);
  const hasProduct = rule.products.includes(serviceCode);

  return hasEntitlement && hasProduct;
});

/**
 * Determines if coupon flag requirements are met based on service code and flag requirements
 * @param {string} serviceCode - The service code to check
 * @param {boolean} isNewCouponsEnabled - Whether the general coupons flag is enabled
 * @param {object|null} enabledCoupon - The coupon object or null
 * @param {object} flagValues - Object containing flag values keyed by flag constant
 * @returns {boolean} - True if coupon flag requirements are met
 */
export const meetsCouponFlagRequirement = (
  serviceCode,
  isNewCouponsEnabled,
  enabledCoupon,
  flagValues
) => {
  if (!isNewCouponsEnabled || !enabledCoupon) return false;

  const requirement = COUPON_FLAG_REQUIREMENTS.find((req) => req.serviceCode === serviceCode);

  if (requirement) {
    return flagValues[requirement.requiredFlag] || false;
  }

  return true;
};
